<footer class="c-footer mt-5">
  <div class="container">
    <div class="c-footer__container">
      <div class="c-footer__redes">
        <div class="region region-footer-first">
          <ul data-region="footer_first" class="c-footer__redes-menu">
            <li class="c-footer__redes-item">
              <div class="c-footer__redes-text">Redes sociales Grupo Bimbo</div>
              <div
                class="menu_link_content menu-link-contentfooter---redes-sociales view-mode-default menu-dropdown menu-dropdown-0 menu-type-default"></div>
            </li>
            <li class="c-footer__redes-item">
              <a
                rel="noopener"
                href="https://www.facebook.com/GrupoBimbo"
                target="_blank"
                class="c-footer__redes-item-link">
                <i class="fab fa-facebook-f fa-sm"></i>
              </a>
            </li>
            <li class="c-footer__redes-item">
              <a
                rel="noopener"
                href="https://www.instagram.com/grupo_bimbo"
                target="_blank"
                class="c-footer__redes-item-link">
                <i class="fab fa-instagram fa-sm"></i>
              </a>
            </li>
            <li class="c-footer__redes-item">
              <a
                rel="noopener"
                href="https://www.linkedin.com/company/grupobimbo"
                target="_blank"
                class="c-footer__redes-item-link">
                <i class="fab fa-linkedin-in fa-sm"></i>
              </a>
            </li>
            <li class="c-footer__redes-item">
              <a
                rel="noopener"
                href="https://www.youtube.com/user/BimboCorporativo"
                target="_blank"
                class="c-footer__redes-item-link">
                <i class="fab fa-youtube fa-sm"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="c-footer__legal">
        <div class="region region-footer-second">
          <ul class="c-footer__legal-menu">
            <li class="c-footer__legal-item">
              <a
                rel="noopener"
                href="http://www.grupobimbo.com"
                class="c-footer__legal-item c-footer__legal-item-link"
                target="_blank">
                www.grupobimbo.com</a
              >
            </li>
            <li class="c-footer__legal-item">
              <a
                rel="noopener"
                href="https://privacy.grupobimbo.com/mexico/policy/index.html"
                class="c-footer__legal-item c-footer__legal-item-link"
                target="_blank">
                Aviso de privacidad</a
              >
            </li>
            <li class="c-footer__legal-item">
              <a
                rel="noopener"
                href="https://terms.grupobimbo.com/m%C3%A9xico/policy"
                class="c-footer__legal-item c-footer__legal-item-link"
                target="_blank"
                >Términos y Condiciones</a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</footer>
